import { useRolodexEntries } from 'features/rolodex'
import { useMemo } from 'react'
import { getSortedAssetModels, RolodexEntryType } from 'types'

export const useAssetOverviewData = (unitID: string | undefined) => {
  const {
    units,
    assetModels,
    components,
    inspections,
    isLoading,
    hasEverLoaded,
    forceRefresh: refreshData,
  } = useRolodexEntries(
    !unitID
      ? undefined
      : {
          type: [
            RolodexEntryType.UNIT,
            RolodexEntryType.ASSET_MODEL,
            RolodexEntryType.COMPONENT,
            RolodexEntryType.INSPECTION,
          ],
          tags: { unit: unitID },
        }
  )

  return useMemo(() => {
    const latestAssetModel = getSortedAssetModels([...assetModels])[0]
    return {
      unit: units.at(0),
      // Sub-unit
      assetModel: latestAssetModel,
      components,
      inspections,
      // Loading & refreshing
      isLoading,
      hasEverLoaded,
      refreshData,
    }
  }, [
    units,
    assetModels,
    components,
    refreshData,
    inspections,
    isLoading,
    hasEverLoaded,
  ])
}
